<template>
  <div>

  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?2661303d